"use client";

import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from 'react-toastify'

import { classNames } from '@/lib/helpers';
import { submitAppSchema } from "@/lib/validations/app";
import { CheckCircleIcon } from "@heroicons/react/20/solid";



export default function AppSubmitForm(
  { type }: 
  { type: string }
) {

  const buttonClass = ""
  const formClass = ""

  const { register, handleSubmit, formState, reset } = useForm({ 
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(submitAppSchema)
  });
  const { errors } = formState;
  const [isFormLoading, setIsFormLoading] = useState(false);  // To disable Button while loading
  const [submittedSuccessfully, setSubmittedSuccessfully] = useState(false);

  // const notify = () => toast("Wow so easy !");

  const postData = async (url, data) => {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }


  const onSubmit = async (data) => {
    setIsFormLoading(true);

    const submitUrl = '/api-new/form-submission'
    const { url, email } = data

    postData(submitUrl, {
      type: 'app-submit',
      submission: { url, email },
    }).then((data) => {
      // console.log(data); // JSON data parsed by `data.json()` call
      setIsFormLoading(false);
      reset();
      setSubmittedSuccessfully(true); 
      // toast.success("Thank you for your submission!");
    }).catch((error) => {
      setIsFormLoading(false);      
      toast.error("Sorry, something went wrong!");
    });

  };

  const errorMessage = (err) => err?.message
  const inputClassName = (err) => classNames(!!err ? 
    "text-red-900 placeholder:text-red-400 focus:ring-red-600 ring-red-300" : 
    "text-gray-900 placeholder:text-gray-400 focus:ring-crisp-600 ring-gray-300",    
    "block w-full rounded-md border-0 py-1.5 px-3  shadow-sm ring-1 ring-inset focus:ring-1 focus:ring-inset  sm:text-sm sm:leading-6 outline-none")



  return (
    <div className="mx-6 sm:mx-auto max-w-2xl   ">
      {submittedSuccessfully ? (

        <div className="px-12 py-12 rounded border border-green-200 bg-green-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800">
                Thank you for your submission!
              </h3>

              <div className="mt-4">
                <div className="-mx-2 -my-1.5 flex">
                  <a
                    href={`/apps/submit-app`}
                    className="rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
                  >
                    Reload
                  </a>

                </div>
              </div>
            </div>
          </div>
          </div>


      ) : (
        <form 
          onSubmit={handleSubmit(onSubmit)} 
          className={classNames(isFormLoading ? 
            "bg-gray-50 animate-pulse " : "bg-white ", 
            "p-6 rounded border border-gray-200")}
        >

          <div className="border-b border-gray-900/10 pb-12">

            {/* <h2 className="text-base font-semibold leading-7 text-gray-900">
              Profile
            </h2>
            <p className="mt-1 text-sm leading-6 text-gray-600">
              This information will be displayed publicly so be careful what you share.
            </p> */}

            <div className="space-y-3">
            
              <div className="">
                <label htmlFor="url" className="block text-sm font-medium leading-6 text-gray-900">
                  URL
                </label>              
                {errorMessage(errors?.url) ? (
                  <p className="mt-1 text-sm leading-6 text-red-600">
                    {errorMessage(errors?.url)}
                  </p>
                ) : null}
                <div className="mt-2">
                  <input {...register("url")} 
                    placeholder="https://yourcompany.com/yourproduct"
                    className={inputClassName(errors.url)}
                  />
                </div>
                <p className="mt-3 text-sm leading-6 text-gray-600">
                  A product URL or the relevant product page on your company's website.
                </p>
              </div>



              <div className="">
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  Contact email
                </label>
                {errorMessage(errors?.email) ? (
                  <p className="mt-1 text-sm leading-6 text-red-600">
                    {errorMessage(errors?.email)}
                  </p>
                ) : null}              
                <div className="mt-2">
                  <input  {...register("email")} 
                    placeholder="john@yourcompany.com"
                    className={inputClassName(errors.email)}
                  />
                </div>
              </div>


            </div>
          </div>




          <div className="mt-6 flex items-center justify-end gap-x-6">
            <button
              type="submit"
              disabled={isFormLoading}
              className={classNames(isFormLoading ? 'animate-pulse' : '', 
                "rounded bg-crisp-600 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-crisp-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-crisp-600")}
            >
              {isFormLoading ? "Submitting ..." : "Submit"}            
            </button>
          </div>

        </form>
      )}
    </div>
  )
}